/**
 * Adapter between the curated IELTS dataset and the trainer's deck shape.
 *
 * `data/ielts-academic.ts` carries more than the trainer needs — topic, part of
 * speech, band, and a Korean prompt alongside the French one. That richness is
 * for later (topic filters, band targeting, a Korean-prompted IELTS deck); the
 * trainer only wants a prompt and its accepted answers. Keeping the mapping
 * here means the dataset never has to be reshaped to fit the app.
 */
import { IELTS_ACADEMIC } from "../data/ielts-academic";
import type { Entry } from "./vocab";

/** French prompt → English answer. The deck the app ships with. */
export const IELTS_FR: Entry[] = IELTS_ACADEMIC.map((item) => ({ w: item.fr, a: item.en }));

/** Korean prompt → English answer. Same curation, not yet surfaced in the UI. */
export const IELTS_KO: Entry[] = IELTS_ACADEMIC.map((item) => ({ w: item.ko, a: item.en }));
